export default __webpack_public_path__ + "static/media/delete.8681579b.svg";